import { render } from "./ViewTransaction.vue?vue&type=template&id=677c9f04&ts=true"
import script from "./ViewTransaction.vue?vue&type=script&lang=ts"
export * from "./ViewTransaction.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__